import { Save, FilePlus2, RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface FooterActionsProps {
  isSubmitting: boolean;
  handleSave: () => void | Promise<void>;
  requestClose: () => void;
  isNameValid: boolean;
  mode: 'create' | 'update';
}

export function FooterActions({
  isSubmitting,
  handleSave,
  requestClose,
  isNameValid,
  mode
}: FooterActionsProps) {
  // Microsoft Word-inspired button text and icons
  const buttonConfig = {
    create: {
      icon: FilePlus2,
      text: 'Crear Workflow',
      loadingText: 'Creando...',
    },
    update: {
      icon: RefreshCw,
      text: 'Guardar Cambios',
      loadingText: 'Guardando...',
    },
  };

  const config = buttonConfig[mode];
  const Icon = config.icon;

  return (
    <TooltipProvider>
      <div className="flex items-center justify-between gap-3 border-t bg-background px-6 py-4">
        {/* Left side: Keyboard shortcut hint */}
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <kbd className="px-1.5 py-0.5 bg-muted border rounded text-[10px] font-mono">Ctrl+S</kbd>
          <span>para guardar</span>
        </div>

        {/* Right side: Action buttons */}
        <div className="flex items-center gap-2">
          <Button
            type="button"
            onClick={handleSave}
            disabled={!isNameValid || isSubmitting}
            className="gap-2"
          >
            <Icon className={`h-4 w-4 ${isSubmitting ? 'animate-spin' : ''}`} />
            {isSubmitting ? config.loadingText : config.text}
          </Button>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={requestClose}
                disabled={isSubmitting}
                aria-label="Cerrar (Esc)"
              >
                <X className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Cerrar (Esc)</TooltipContent>
          </Tooltip>
        </div>
      </div>
    </TooltipProvider>
  );
}
